import React, { PropsWithChildren } from 'react'

export enum OfferListEvents {
  productClick,
  impression,
  listLoad,
  clientAction,
}

type OfferListAction = (action: OfferListEvents, data?: any) => void
const OfferListEventsContext = React.createContext<OfferListAction>(undefined)

interface Props {
  onListEvent: OfferListAction;
}

export function OfferListEventsProvider(props: PropsWithChildren<Props>) {
  return <OfferListEventsContext.Provider value={props.onListEvent}>
    {props.children}
  </OfferListEventsContext.Provider>
}

export default OfferListEventsContext
